import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { ColumnsTable } from 'safe'
import AdvancedAccountingRecord from '../../components/Display/AdvancedAccountingRecord'
import FloatingForm from '../../components/Display/FloatingForm'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Table from '../../components/Display/Table'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { HeaderProps } from '../../components/Layout/Header'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { formatPipe, getYearMonthAndDay, transformDate } from '../../utils/utils'
import AccountingRecordForm from './AccountingRecordForm'
import { RootState } from '../../redux/store'
import { useSelector } from 'react-redux'
const server = process.env.REACT_APP_SERVER_URL

const AccountingRecord: React.FC<IAccountingRecords> = ({
  setHeaderActions,
}) => {
  const [
    accountingRecordState,
    setAccountingRecord,
  ] = useState<IAccountingRecord>({
    accountingRecords: [],
    numberOfPages: 0,
    currentPage: 0,
    searchParams: [],
    loading: false,
  })

  const { addAlert } = useSnackBars()

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const [showModal, setShowModal] = useState<boolean>(false)

  const [showSearchModal, setShowSearchModal] = useState<boolean>(false)

  const [confirmModal, setConfirmModal] = useState<boolean>(false)

  const [accountingRecordToDelete, setAccountingRecordToDelete] = useState<
    any[]
  >([])

  const [userConfig] = useLocalStorageState('user-config')

  const [fastSearch, setFastSearch] = useState<string>('')

  const {
    accountingRecords,
    numberOfPages,
    currentPage,
    searchParams,
    loading,
  } = accountingRecordState

  const columns: ColumnsTable[] = [
    {
      title: 'Fecha',
      dataIndex: 'date',
      key: 'date',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {transformDate(record?.date)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {formatPipe(record?.amount)}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      render: (id: number, record: any) => {
        let objTransform = {
          CREDIT: 'Haber',
          DEBIT: 'Debe',
        }
        return (
          <ColumnItemWrapper subElement="paragraph">
            {objTransform[record?.type]}
          </ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Código cuenta contable',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'Cuenta contable',
      dataIndex: 'name',
      key: 'name',
      tootltipValue: true
    },
    {
      title: 'Usuario',
      dataIndex: 'username',
      key: 'username',
    },
  ]

  const getAccountingRecord = async (
    querySearch: string[] = searchParams,
    page: number = currentPage,
    fastParam = fastSearch
  ) => {

    setAccountingRecord((prevState) => ({
      ...prevState,
      loading: true,
      searchParams: querySearch,
      currentPage: page
    }))

    let paginationParams: string[] = [
      `pageNumber=${page + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    setFastSearch(fastParam)

    let newParams = [...querySearch]

    if (fastParam) {
      newParams.push(`description=${fastParam}`)
    }

    try {
      let response = await axios.get<{
        records: IAccountingRecord[]
        numberOfPages: string
      }>(
        `${server}/accounting/record?${[
          ...paginationParams,
          ...newParams,
        ].join('&')}`
      )
      setAccountingRecord((prevState) => ({
        ...prevState,
        accountingRecords: response?.data?.records,
        loading: false,
        numberOfPages: +response?.data?.numberOfPages || 1,
      }))
    } catch (err) {
      addAlert({
        message: 'Error al obtener registros contables',
        status: 'error',
      })
    }
  }

  useEffect(() => {
    getAccountingRecord()
  }, [])

  const filterHeader = (values) => {
    if (accountingRecordToDelete.length == 0) {
      const { onDeletePending, ...rest } = values
      return rest
    }
    return values
  }

  useEffect(() => {

    if (userRole === "seniat") {
      setHeaderActions(
        filterHeader({
          advancedSearch: (value) => {
            if (typeof value === 'boolean') {
              // setModalSearch(true)
              // setShowModal(true)
              setShowSearchModal(true)
              return
            }
            // setSearchParams([`fastSearch=${value}`])
            getAccountingRecord([], 0, value)
          },
          //   searchAction: () => {
          //     // setShowModal(true)
          //   },
         
          cleanFilters: {
            sort: () => {},
            search: () => {
              getAccountingRecord([], 0)
            },
            isSearch: Boolean(searchParams.length > 0),
          },
          onDeletePending: async () => {
              setConfirmModal(true)
          },
        })
      )

    } else {
      setHeaderActions(
        filterHeader({
          advancedSearch: (value) => {
            if (typeof value === 'boolean') {
              // setModalSearch(true)
              // setShowModal(true)
              setShowSearchModal(true)
              return
            }
            // setSearchParams([`fastSearch=${value}`])
            getAccountingRecord([], 0, value)
          },
          //   searchAction: () => {
          //     // setShowModal(true)
          //   },
          addAction: () => {
            setShowModal(true)
          },
          cleanFilters: {
            sort: () => {},
            search: () => {
              getAccountingRecord([], 0)
            },
            isSearch: Boolean(searchParams.length > 0),
          },
          onDeletePending: async () => {
              setConfirmModal(true)
          },
        })
      )
    }

  

    return () => {
      setHeaderActions(null)
    }

  }, [setHeaderActions, searchParams, currentPage, accountingRecordToDelete, userRole])

  return (
    <div>
      <Table
        columns={columns}
        data={accountingRecords}
        loading={loading}
        pages={numberOfPages}
        pageSelected={currentPage}
        setPageSelected={(page) => getAccountingRecord(searchParams, page)}
        isArraySelectable={userRole === "seniat" ? false : true}
        selectedData={accountingRecordToDelete}
        setSelectedData={(data) => {
          setAccountingRecordToDelete(data)
          // setAccountPayableToAdd(data)
          // setBillsToPayToAdd(data)
        }}
      />

      <Modal
        display={showModal}
        onClose={() => setShowModal(false)}
        xlClasses="w-[650px]"
      >
        <AccountingRecordForm
          onClose={() => setShowModal(false)}
          onSubmit={async (values) => {
            try {
              addAlert({
                message: 'Creando registro contable...',
                status: 'loading',
              })
              await axios.post(`${server}/accounting/record`, values)
              addAlert({
                message: 'Registro contable creado con éxito',
                status: 'success',
              })
              setShowModal(false)
            } catch (err) {
              addAlert({
                message: 'Error al crear el registro contable',
                status: 'error',
              })
              return
            }
            getAccountingRecord([], 0)
          }}
        />
      </Modal>

      <FloatingForm
        visible={showSearchModal}
        onClose={() => setShowSearchModal(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        <AdvancedAccountingRecord
          onClose={() => setShowSearchModal(false)}
          onSubmit={async (values) => {
            if (values.isDateSelected) {
              const [yearFrom, monthFrom, dayFrom] = getYearMonthAndDay(
                values.fromDate
              )
              const [yearTo, monthTo, dayTo] = getYearMonthAndDay(values.toDate)
              let from = new Date(yearFrom, monthFrom, dayFrom)
              let to = new Date(yearTo, monthTo, dayTo + 1)
  
              let dateFrom = DateTime.fromISO(from.toISOString()).toISODate()
              let datePrueba = DateTime.fromISO(to.toISOString()).toISODate()
  
              values.fromDate = dateFrom
  
              values.toDate = datePrueba
            }

            if (!values.isDateSelected) {
              delete values.fromDate
              delete values.toDate
              delete values.isDateSelected
            }

            let params = Object.keys(values).reduce((a, b) => {
              if (values[b]) {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)

            await getAccountingRecord(params, 0)
            setShowSearchModal(false)
          }}
        />
      </FloatingForm>

      <ModalConfirm
        displayConfirmModal={confirmModal}
        onCancel={() => setConfirmModal(false)}
        title="¿Está seguro que desea eliminar los registros contables?"
        onConfirm={async () => {
          try {
            await Promise.all(
              accountingRecordToDelete.map(async (v) => {
                return await axios.delete(
                  `${server}/accounting/record?id=${v.id}`
                )
              })
            )
            addAlert({
                message: 'Registros contables eliminados satisfactoriamente',
                status: 'success',
              })
          } catch (err) {
            addAlert({
              message: 'Error al eliminar cualquier registro',
              status: 'error',
            })
          } finally {
            await getAccountingRecord([], 0)
            setConfirmModal(false)
            setAccountingRecordToDelete([])
          }
        }}
      />
    </div>
  )
}

interface IAccountingRecord {
  accountingRecords: IAccountingRecord[]
  numberOfPages: number
  currentPage: number
  searchParams: string[]
  loading: boolean
}

interface IAccountingRecords {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}

export default AccountingRecord
